import { QcUserSchema } from "@/modules/staff/objects/conversation/QcUser";
import { z } from "zod";
import { MemberRoleZod } from "./MemberRole";
import { JoinStatusZod } from "./JoinStatus";
import { NotificationRangeZod } from "./NotificationRange";

export type QcConversationMember = z.infer<typeof QcConversationMemberSchema>;
export const QcConversationMemberSchema = z.object({
  id: z.number(),
  id_account: z.number(),
  invite_user_id_account: z.number().nullable(),
  conversation_name: z.string(),
  qr: z
    .string()
    .nullable()
    .transform((value) => value ?? ""),
  role: MemberRoleZod,
  join_status: JoinStatusZod,
  notification_range: NotificationRangeZod,
  created_at: z.string(),
  updated_at: z.string(),
  user: QcUserSchema,
  conversation_id: z.string(),
});
